import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { filterSelectedSessions } from "../helpers/Sessions/sessionsDetailsHelpers";
import SessionalDetailsAction from "@common/redux/actions/SessionalDetailsAction";
import LinkSessionAction from "@common/redux/actions/LinkSessionAction";
import LinkAlertAction from "@common/redux/actions/LinkAlertAction";
import ConfirmModalAction from "@common/redux/actions/ConfirmModalAction";

const useLinkedSession = () => {
  const { control, setValue } = useFormContext();

  const setState = (data) => LinkSessionAction.dispatch(data);
  const data = useSelector((state) => LinkSessionAction.getStatePath(state));
  const details = useSelector((state) =>
    SessionalDetailsAction.getStatePath(state),
  );

  const alertsData = useSelector((state) =>
    LinkAlertAction.getStatePath(state),
  );

  const sessionsToBeDeleted = filterSelectedSessions(data.linkedSessionData);

  const setMachine = ({ installationId }) =>
    setValue("machine", { installationId }, { shouldValidate: true });

  const setAccordionIndex = (indices) =>
    setState({ activeAccordionIndex: indices });

  const confirmRemoveSessions = (sessionsToBeDeleted, linkedAlertData) => {
    if (!linkedAlertData) return;
    const sessionLinkedToTriggeredAlerts = linkedAlertData.some((alert) =>
      sessionsToBeDeleted.find(
        (session) => alert.sessionId === session.sessionId,
      ),
    );
    if (sessionLinkedToTriggeredAlerts)
      ConfirmModalAction.open(
        "This session is linked to the triggered alert, are you sure you want to remove this?",
        "Confirm remove alerts",
        () => removeSelectedSessions(sessionsToBeDeleted),
      );
    else removeSelectedSessions(sessionsToBeDeleted);
  };

  const removeSelectedSessions = (sessionsToBeDeleted) => {
    const updatedData =
      LinkSessionAction.removeSelectedSessions(sessionsToBeDeleted);
    const sessionGuids = updatedData.map((x) => x.sessionGuid);
    setValue("sessionGuids", sessionGuids, { shouldValidate: true });
  };

  return {
    ...data,
    ...alertsData,
    control,
    setState,
    setValue,
    setAccordionIndex,
    details,
    sessionsToBeDeleted,
    confirmRemoveSessions,
    removeSelectedSessions,
    setMachine,
  };
};

export default useLinkedSession;
